// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var TailwindVariants = require("tailwind-variants");

var focusRing = TailwindVariants.tv({
      base: "outline outline-tan-blue-500 outline-0 focus-visible:outline-2",
      variants: {
        isFocusVisible: {
          false: "outline-0",
          true: "outline-2"
        }
      }
    });

var Utils = {
  focusRing: focusRing
};

exports.Utils = Utils;
/* focusRing Not a pure module */
